import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { TabBar } from './components/TabBar';
import { OnboardingModal } from './components/OnboardingModal';
import { HomeScreen } from './screens/HomeScreen';
import { StopDetailScreen } from './screens/StopDetailScreen';
import { TripPlannerScreen } from './screens/TripPlannerScreen';
import { LiveMapScreen } from './screens/LiveMapScreen';
import { AlertsScreen } from './screens/AlertsScreen';
import { JourneyDetailScreen } from './screens/JourneyDetailScreen';
import { RouteMapScreen } from './screens/RouteMapScreen';
import { SettingsScreen } from './screens/SettingsScreen';

export function App() {
  return (
    <BrowserRouter>
      <OnboardingModal />
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/stop/:stopId" element={<StopDetailScreen />} />
        <Route path="/plan" element={<TripPlannerScreen />} />
        <Route path="/map" element={<LiveMapScreen />} />
        <Route path="/alerts" element={<AlertsScreen />} />
        <Route path="/journey" element={<JourneyDetailScreen />} />
        <Route path="/route-map" element={<RouteMapScreen />} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <TabBar />
    </BrowserRouter>
  );
}
